import React from 'react';

import StorageBrazeCard from 'src/cms-components/StorageBrazeCard/StorageBrazeCard';
import { NerdMenuElementType } from 'src/common/enums';
// import { useBrazeContext } from 'src/hooks/useBraze/useBraze';
import NerdMenuLinkListWrapper from './NerdMenuLinkListWrapper';

interface NerdMenuElementsProps {
  menuElement: NerdMenuElement;
}

const NerdMenuElementsColumns: React.FC<{ columns: NerdMenuElement[] }> = ({ columns }) => {
  return (
    <div className="pds-grid pds-grid-cols-[repeat(auto-fit,minmax(200px,1fr))] pds-gap-4">
      {columns.map(column => {
        const elements = column.menuElements || [];

        const linkListWrappers = elements.filter(
          element => element.type === NerdMenuElementType.LINK_LISTS_WRAPPER,
        );

        if (linkListWrappers.length === 0) {
          // eslint-disable-next-line no-console
          console.error('No link list wrappers found in column', column);
          return null;
        }

        return (
          <div key={column.title} className="pds-flex pds-flex-col pds-gap-4">
            {linkListWrappers.map(element => {
              return <NerdMenuLinkListWrapper key={element.title} linkListWrapper={element} />;
            })}
          </div>
        );
      })}
    </div>
  );
};

const NerdMenuElementsComponents: React.FC<{
  componentElement: NerdMenuElement;
}> = ({ componentElement }) => {
  // TODO: Implement braze context for header menu
  // const { brazeCardPayloads } = useBrazeContext();

  const component = componentElement?.component;

  if (component?.type === 'storage__braze_card') {
    return (
      <div className="pds-h-[500px] pds-max-w-[280px]">
        {/* <StorageBrazeCard defaultCard={component} brazeCard={brazeCardPayloads[0]} /> */}
        <StorageBrazeCard defaultCard={component} />
      </div>
    );
  }

  // eslint-disable-next-line no-console
  console.error('Unknown component type', componentElement);
  return null;
};

const NerdMenuElements: React.FC<NerdMenuElementsProps> = function ({ menuElement }) {
  const menuElements = menuElement.menuElements || [];
  const columns = menuElements.filter(x => x.type === NerdMenuElementType.COLUMN);
  const componentElements = menuElements.filter(x => x.type === NerdMenuElementType.COMPONENT);
  const componentElement = componentElements.length > 0 ? componentElements[0] : undefined;

  if (componentElements.length > 1) {
    // eslint-disable-next-line no-console
    console.error('There should only be one component at the column level', componentElements);
  }

  return (
    <div className="pds-flex pds-flex-row pds-justify-between pds-gap-6">
      <div className="pds-flex pds-flex-grow pds-flex-col pds-gap-4">
        <h2 className="menu-heading pds-text-title-md">{menuElement.title}</h2>

        <NerdMenuElementsColumns columns={columns} />
      </div>

      {componentElement && <NerdMenuElementsComponents componentElement={componentElement} />}
    </div>
  );
};

export default NerdMenuElements;
